// Auto-generated flat translation map assembled from per-namespace files.
// Add new keys to the matching <namespace>.json (create one per module).
// Key format: <namespace>.<area>.<slug> — flat dotted strings.
import ai from "./ai.json";
import aiTools from "./aiTools.json";
import appointments from "./appointments.json";
import appstore from "./appstore.json";
import calendar from "./calendar.json";
import common from "./common.json";
import company from "./company.json";
import contacts from "./contacts.json";
import crm from "./crm.json";
import crm_proposals from "./crm_proposals.json";
import csat from "./csat.json";
import dashboard from "./dashboard.json";
import email from "./email.json";
import header from "./header.json";
import helpdesk from "./helpdesk.json";
import huddle from "./huddle.json";
import inbox from "./inbox.json";
import knowledge from "./knowledge.json";
import lang from "./lang.json";
import login from "./login.json";
import loyalty from "./loyalty.json";
import marketing from "./marketing.json";
import monitoring from "./monitoring.json";
import nav from "./nav.json";
import nexus from "./nexus.json";
import notifications from "./notifications.json";
import page from "./page.json";
import partner from "./partner.json";
import profile from "./profile.json";
import projects from "./projects.json";
import quick_create from "./quick_create.json";
import regulatory from "./regulatory.json";
import sentiment from "./sentiment.json";
import settings from "./settings.json";
import sidebar from "./sidebar.json";
import social_media from "./social_media.json";
import trial_expired from "./trial_expired.json";
import unauthorized from "./unauthorized.json";
import users from "./users.json";
import validation from "./validation.json";
import tour from "./tour.json";
import voice from "./voice.json";

const translations = {
  ...ai,
  ...aiTools,
  ...appointments,
  ...appstore,
  ...calendar,
  ...common,
  ...company,
  ...contacts,
  ...crm,
  ...crm_proposals,
  ...csat,
  ...dashboard,
  ...email,
  ...header,
  ...helpdesk,
  ...huddle,
  ...inbox,
  ...knowledge,
  ...lang,
  ...login,
  ...loyalty,
  ...marketing,
  ...monitoring,
  ...nav,
  ...nexus,
  ...notifications,
  ...page,
  ...partner,
  ...profile,
  ...projects,
  ...quick_create,
  ...regulatory,
  ...sentiment,
  ...settings,
  ...sidebar,
  ...social_media,
  ...trial_expired,
  ...unauthorized,
  ...users,
  ...validation,
  ...tour,
  ...voice,
};

export default translations;
